import styled from 'styled-components';

import {Device} from '../../../constants';

import {StyledCtaContent} from './';

const StyledCtaHeaderContent = styled(StyledCtaContent)`
  && h3 {
    font-size: 2em;
    letter-spacing: 10px;
  }

  @media screen and ${Device.laptopL} {
    width: 100%;
    margin: 0 auto;
  }

  @media screen and ${Device.mobileL} {
    &&&& h3 {
      font-size: 1.5em;
    }
  }
`;

export default StyledCtaHeaderContent;
